import { InlineImageFormSchema } from '../typings/inline-image-form';

export const DEFAULT_MODE_CONTENT: InlineImageFormSchema = {
};
